import styled from 'styled-components'

export const ContentSection = styled.div<{ isVisible?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  padding: 8px 32px 32px;
  border-radius: 10px;
  background: #fdfdfd;
  box-shadow: 4px 0px 8px 0px rgba(142, 146, 188, 0.05);

  .content-childrens {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
  }

  .content-children {
    display: flex;
    width: 80%;

    @media (max-width: 768px) {
      width: 100%;
    }
  }

  .full-space-section {
    display: flex;
    width: 100%;

    .content-children {
      width: 100%;
      flex-direction: column;
    }
  }

  @media (max-width: 768px) {
    padding: 8px 15px 22px;
    text-align: left;
  }
`

export const ContentHeader = styled.div<{
  $flexDirection?: string
  $alignItems?: string
}>`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 8px;
  flex-direction: ${({ $flexDirection }) => $flexDirection};
  align-items: ${({ $alignItems }) => $alignItems};

  .children-2-mobile {
    @media (max-width: 768px) {
      display: flex;
      align-items: flex-end;
    }
    @media (min-width: 769px) {
      display: none;
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
`

export const ContentTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  h1 {
    color: #0a0a18;

    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%; /* 30px */
    letter-spacing: -0.4px;
    margin-bottom: 7px;
  }
  h3 {
    color: #313131;

    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 21px */
    letter-spacing: -0.28px;
  }
`
export const CTAContainer = styled.div`
  display: flex;
  gap: 8px;

  @media (max-width: 768px) {
    margin-bottom: 10px;
  }
`

export const BackButton = styled.button`
  font-size: 24px;
  background: transparent;
  border: none;
  padding: 0;
  margin: 0 5px 0 0;
`

export const ContentChildren2 = styled.div`
  @media (max-width: 768px) {
    display: none;
  }

  @media (min-width: 769px) {
    display: flex;
    align-items: flex-end;
  }
`
